import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { CommonStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import { Point } from "pixi.js";
import { ViewProperties } from "../../../utils/ViewProperties";
import { GameStyle } from "../style/GameStyle";
/**
 * Game-specific background properties.
 */
export class GameBackgroundProperties extends ViewProperties {
    constructor() {
        super(...arguments);
        this.backgroundProperties = new SpineProperties(CommonStyle.BACKGROUND, GameStyle.MODULE);
        this.borderProperties = new SpriteProperties(GameStyle.GRID_BORDER, GameStyle.MODULE, new Point(0, 40), null, new Point(0.5, 0.5));
    }
}
//# sourceMappingURL=GameBackgroundProperties.js.map